define.alias("shared/utils/compare-strings", "settings/utils/compare-strings");